import React from 'react';
import AvatarUpload from '../components/ui/AvatarUpload';
import './profile-sidebar.scss';

const ProfileSidebar = ({ profile, activeTab, onTabChange, onChangePassword, onAvatarUpdate }) => {
    return (
        <div className="profile-sidebar">
            <div className="user-card">
                {/* Sostituisci il div statico con il componente dinamico */}
                <AvatarUpload 
                    avatarUrl={profile?.avatar_url}
                    onAvatarUpdate={onAvatarUpdate}
                    size={100}
                />
                
                <h3>{profile?.nome_utente} {profile?.cognome_utente}</h3>
                <p>{profile?.email_utente}</p>
            </div>

            <nav className="profile-nav">
                <button 
                    className={`nav-item ${activeTab === 'info' ? 'active' : ''}`}
                    onClick={() => onTabChange('info')}
                >
                    <span className="nav-icon">👤</span>
                    Informazioni Personali
                </button>
                <button 
                    className={`nav-item ${activeTab === 'addresses' ? 'active' : ''}`}
                    onClick={() => onTabChange('addresses')}
                >
                    <span className="nav-icon">📍</span>
                    Indirizzi
                </button>
                <button 
                    className={`nav-item ${activeTab === 'orders' ? 'active' : ''}`}
                    onClick={() => onTabChange('orders')}
                >
                    <span className="nav-icon">📦</span>
                    I Miei Ordini
                </button>
            </nav>

           <div className="sidebar-footer">
                <button className="change-password-btn" onClick={onChangePassword}>
                    🔒 Cambia Password
                </button>
            </div>
        </div>
    );
};

export default ProfileSidebar;
